import { useState } from "react";
import { MapPin, RadioTower, Square } from "lucide-react";
import { Button, Card } from "../components/ui";

export default function GpsTeste() {
  const [resultado, setResultado] = useState("");
  const [watchId, setWatchId] = useState(null);

  const testarUmaVez = () => {
    if (!navigator.geolocation) {
      setResultado("Geolocalização não suportada neste navegador.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;
        setResultado(
          `Latitude: ${latitude}\nLongitude: ${longitude}\nPrecisão (m): ${accuracy}\nTimestamp: ${new Date(
            pos.timestamp
          ).toLocaleString("pt-BR")}`
        );
      },
      (err) => {
        setResultado(`Erro: ${err.code} - ${err.message}`);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  };

  const iniciarWatch = () => {
    if (!navigator.geolocation) {
      setResultado("Geolocalização não suportada neste navegador.");
      return;
    }

    const id = navigator.geolocation.watchPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;
        setResultado(
          `Atualizando...\nLatitude: ${latitude}\nLongitude: ${longitude}\nPrecisão (m): ${accuracy}\nTimestamp: ${new Date(
            pos.timestamp
          ).toLocaleString("pt-BR")}`
        );
      },
      (err) => {
        setResultado(`Erro: ${err.code} - ${err.message}`);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );

    setWatchId(id);
  };

  const pararWatch = () => {
    if (watchId != null) {
      navigator.geolocation.clearWatch(watchId);
      setWatchId(null);
      setResultado((prev) => `${prev}\n\nMonitoramento encerrado.`);
    }
  };

  return (
    <div className="app-shell space-y-4">
      <header className="page-header">
        <h1 className="page-title">Teste de GPS</h1>
        <p className="page-subtitle">Validação rápida de coordenadas para check-in/check-out.</p>
      </header>

      <Card>
        <div className="flex flex-col gap-2 sm:flex-row">
          <Button onClick={testarUmaVez}>
            <MapPin className="h-4 w-4" />
            Testar uma vez
          </Button>
          <Button variant="outline" onClick={iniciarWatch} disabled={watchId != null}>
            <RadioTower className="h-4 w-4" />
            Iniciar monitoramento
          </Button>
          <Button variant="secondary" onClick={pararWatch} disabled={watchId == null}>
            <Square className="h-4 w-4" />
            Parar
          </Button>
        </div>

        <pre className="mt-4 overflow-x-auto rounded-lg border border-border bg-muted/35 p-3 text-xs sm:text-sm">
          {resultado || "Clique em \"Testar uma vez\" para iniciar."}
        </pre>
      </Card>
    </div>
  );
}
